if (!customElements.get('aryveda-ingredients')) {
  class AryvedaIngredients extends HTMLElement {
    constructor() {
      super();

      this.cards = Array.from(this.querySelectorAll('.ald-ingredient-card'));
      this.cards.forEach((card) => {
        const trigger = card.querySelector('.ald-ingredient-card__trigger');
        if (trigger) trigger.addEventListener('click', () => this.toggle(card));
      });
    }

    toggle(card) {
      const isOpen = card.classList.contains('is-open');

      this.cards.forEach((otherCard) => {
        if (otherCard !== card) this.close(otherCard);
      });

      if (isOpen) {
        this.close(card);
      } else {
        this.open(card);
      }
    }

    open(card) {
      const panel = card.querySelector('.ald-ingredient-card__panel');
      const trigger = card.querySelector('.ald-ingredient-card__trigger');

      card.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (panel) panel.style.maxHeight = `${panel.scrollHeight}px`;
    }

    close(card) {
      const panel = card.querySelector('.ald-ingredient-card__panel');
      const trigger = card.querySelector('.ald-ingredient-card__trigger');

      card.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.style.maxHeight = null;
    }
  }

  customElements.define('aryveda-ingredients', AryvedaIngredients);
}
